import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { VehiclesService } from 'src/app/services/vehicles.service';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.page.html',
  styleUrls: ['./add-vehicle.page.scss'],
})
export class AddVehiclePage implements OnInit {
  nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getFullYear()
  @Input() vehicles: object;
  addVehicleForm: FormGroup;
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private loaderSRV:LoaderService,
    private toastSRV:ToastService,
    public alertController: AlertController,
    public modalController: ModalController,
    private fb: FormBuilder,
    public dataService: DataService,
    public translateService: TranslateService,
    public vehiclesSRV:VehiclesService,
  ) {}

  ngOnInit() {
    this.addVehicleForm = this.fb.group({
      Plate: ['', [Validators.required]],
      vin: [''],
      ProvID: [this.vehiclesSRV?.provinces[0].ProvID, [Validators.required]],
      PlateTypeID: [this.vehiclesSRV?.plateTypes[0].TypeID, [Validators.required]],
      MakeID: [this.vehiclesSRV?.makes[0].MakeID, ],
      TypeID: [this.vehiclesSRV?.types[0].TypeID, ],
      ColourID: [this.vehiclesSRV?.colours[0].ColourID, ],
      Year: ['', [Validators.min(1900),Validators.max(this.nextYear),Validators.maxLength(4),Validators.minLength(4)]],
      electric_vehicle:[false]
    });
  }
  onCloseModal() {
   
    this.modalController.dismiss({
      reload: false,
    });
  }
  onSaveChanges() {
    this.loaderSRV.showLoader((this.translateService.instant('keys.data.common.loading') || 'Loading...'))
    const url = 'vehicles/create';
    const data = this.addVehicleForm.value;

    this.dataService.postData(url, data).subscribe( {
      next:res=>{
        this.loaderSRV.dismissLoader()
        if(res['status']=='success'){
          this.toastSRV.presentToast(res['message'])
          this.modalController.dismiss({
            reload: true,
          });
        } else {
          
          this.errorHandlerSRV.displayErrorMessage(res,true)
        }
      },
      error:err=> {
        if(err?.prompt_to_add==true){
          this.presentPrompt(err)
        } 
        else {
          this.errorHandlerSRV.displayErrorMessage(err,true)
        }
      }
      
     
    });
  }
  async presentPrompt(error) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      message: error?.message,
      buttons: [
         {
          text:this.translateService.instant('keys.data.common.cancel') || 'Cancel',
          role: 'cancel',
          handler: () => {
           
          },
        },
        {
          text: this.translateService.instant('keys.data.vehicles.add_vehicle') || 'Add New Vehicle',
          role: 'confirm',
          handler: () => {
            this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
            this.dataService.postDataWithFullURL(error.form_action, {}).subscribe({
              next:(res:any)=>{
               
                if(res['status']=='success'){
                  this.toastSRV.presentToast(res?.message)
                  this.loaderSRV.dismissLoader()
                  this.modalController.dismiss({
                    reload: true,
                  });
              } else {
                this.loaderSRV.dismissLoader()
                this.errorHandlerSRV.displayErrorMessage(res,true)
              }
              
              },error:err=>{
                this.errorHandlerSRV.displayErrorMessage(err,true)
              }
            })
          }
          },
      ],
    });

    await alert.present();
  }
}
